export const SEARCH_STORAGE_KEY = 'hyosung-search-state-v3';


export function loadStoredSearchState() {
    try {
        const raw = window.sessionStorage.getItem(SEARCH_STORAGE_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch (_error) {
        return null;
    }
}


export function saveStoredSearchState(payload) {
    try {
        window.sessionStorage.setItem(SEARCH_STORAGE_KEY, JSON.stringify(payload));
    } catch (_error) {
        // ignore session storage errors in local shell
    }
}


export function clearStoredSearchState() {
    try {
        window.sessionStorage.removeItem(SEARCH_STORAGE_KEY);
    } catch (_error) {
        // ignore session storage errors in local shell
    }
}


export function updateStoredSearchItem(nextItem) {
    const current = loadStoredSearchState();
    if (!current?.resultState?.items?.length) {
        return;
    }

    const nextItems = current.resultState.items.map((item) => (
        item.id === nextItem.id ? nextItem : item
    ));

    saveStoredSearchState({
        ...current,
        resultState: {
            ...current.resultState,
            items: nextItems,
        },
    });
}
